import { Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';


let _selectedStore = new Map({
    service: null,
    leg: null
});

class SelectedStore extends BaseStore {

    getService() { return _selectedStore.get('service'); }

    getLeg() { return _selectedStore.get('leg'); }

    handleServiceSelected (action) {
        const isSameService = action.service === _selectedStore.get('service');
        const activeService = !isSameService ? action.service : null;

        _selectedStore = _selectedStore
            .set('service', activeService)
            .set('leg', null);

        this.emitChange();
    }

    handleLegSelected (action) {
        const isSameLeg = action.leg === _selectedStore.get('leg');
        const activeLeg = !isSameLeg ? action.leg : null;
        _selectedStore = _selectedStore.set('leg', activeLeg);

        this.emitChange();
    }

    handleSearchStarted () {
        _selectedStore = _selectedStore.set('leg', null).set('service', null);
        this.emitChange();
    }

    getActionHandlers () {
        return {
            [ActionTypes.SERVICE_SELECTED]: this.handleServiceSelected,
            [ActionTypes.LEG_SELECTED]: this.handleLegSelected,
            [ActionTypes.SEARCH_STARTED]: this.handleSearchStarted
        };
    }

}


const storeInstance = new SelectedStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/SelectedStore.js